import { ModalBase } from 'uiKit/atoms/ModalBase/ModalBase';
import { Fade } from 'uiKit/atoms/Fade/Fade';
import { Box } from 'uiKit/atoms/Box/Box';
import cn from 'classnames';
import styles from '../Modal/Modal.module.scss';

import { Header } from './Header';
import { Content } from './Content';
import { Footer } from './Footer';

type ModalProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  wrapperClassName?: string;
  title?: string;
  footer?: React.ReactNode;
};

export const Modal = ({ open, title, onClose, children, footer, wrapperClassName }: ModalProps) => {
  return (
    <ModalBase
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={false}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open} timeout={300} mountOnEnter unmountOnExit>
        <Box
          tabIndex={-1}
          role="dialog"
          aria-modal="true"
          data-testid="base-modal"
          className={cn(styles.modal__overlay)}
        >
          <Box className={cn(styles.modal__container, wrapperClassName)}>
            <Header title={title} onClose={onClose} />
            <Content>{children}</Content>
            <Footer>{footer}</Footer>
          </Box>
        </Box>
      </Fade>
    </ModalBase>
  );
};
export default Modal;
